import React from 'react';
import { ArrowRightOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Card, Row, Button, Tooltip } from 'antd';
import { withRouter } from 'react-router-dom';
import CustomerMainLayout from '../../CustomerComponents/CustomerMainLayout/CustomerMainLayout';
import CustomerOnboarding from '../../CustomerComponents/CustomerOnboarding';

class ProductModelRequest extends React.Component {

    state = {
        onboarding: false
    }

    componentDidMount() {
        let onboarding = new URLSearchParams(window.location.search).get("onboarding");
        if(onboarding != undefined){
            if (typeof(onboarding == 'string') || onboarding instanceof String)
            {
                onboarding = (onboarding.toLowerCase() === 'true');
            }

            if (onboarding == false) {
                this.setState({
                    onboarding: false
                });
            }
            else{  
                this.setState({
                    onboarding: true
                });
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            let onboarding = new URLSearchParams(window.location.search).get("onboarding");
            if(onboarding != undefined){
                if (typeof(onboarding == 'string') || onboarding instanceof String)
                {
                    onboarding = (onboarding.toLowerCase() === 'true');
                }
                if (onboarding == false) {
                    this.setState({
                        onboarding: false
                    });
                }
                else{  
                    this.setState({
                        onboarding: true
                    });
                }
            }
        }
    }

    createNewProductPage() {
        if(this.state.onboarding){
            this.props.history.push({
                pathname: '/add-new-product?origin=/new-product-model',
                search: `${this.props.location.search}`
            });
        }
        else{
            window.location.href="/add-new-product?origin=/new-product-model";
        }
    }

    render () {
        return (
            <CustomerMainLayout selected='3'>
               <div>
                <div style={{display: "flex", justifyContent: "space-around", marginTop: 100}}>
                    <Row>
                        <Card style={{marginRight: 12,padding:20}} bodyStyle={{width: 420, textAlign:"center"}} data-tut="reactour__upload_existing">
                            <img style={{width: 120, marginBottom: 20,marginTop: 60}} alt="Existing Physical Product" src={"/img/3d-file.png"}></img>
                            <span style={{marginTop: 20}}>
                                <h3 className="manrope f-18 black-14 w-600 justify-in-center" >Existing Physical Product&nbsp;&nbsp;<Tooltip title={<span className='manrope f-12 white'>If you have an existing physical product and you have images of that product, use this form. </span>}><InfoCircleOutlined/></Tooltip></h3>
                            </span>
                            <Button shape="round"className="modal-okay-orange font-14 square w-900" type={this.state.onboarding?"danger":"danger"} style={{margin: "20px auto 60px auto"}}  onClick={() => window.location.href="/create-existing-physical-product?origin=/new-product-model"} disabled={this.state.onboarding?true:false}>
                                Create <ArrowRightOutlined />
                            </Button>
                        </Card>
                        <Card style={{marginLeft: 12,padding:20}} bodyStyle={{width: 420, textAlign:"center"}} data-tut="reactour__create_product_model">
                            <img style={{width: 120, marginBottom: 20,marginTop: 60}} alt="Create Product Model" src={"/img/creativity.png"}></img>
                            <span style={{marginTop: 20}}>
                                <h3 className="manrope f-18 black-14 w-600 justify-in-center">Design A New Product&nbsp;&nbsp;<Tooltip title={<span className='manrope f-12 white'>If your product is in design and you only have sketches and CADs, use this form.</span>}><InfoCircleOutlined/></Tooltip></h3>
                            </span>
                            <Button shape="round" type="danger"  className="modal-okay-orange square font-14 w-900" style={{margin: "20px auto 60px auto"}} onClick={() => this.createNewProductPage()}>
                              Create<ArrowRightOutlined />
                            </Button>
                        </Card>
                        
                        
                    </Row>

                </div>
                {this.state.onboarding? 
                <CustomerOnboarding step_no={20}/>
                :""
                }
            </div>
            </CustomerMainLayout>
        );
    }
}

export default withRouter(ProductModelRequest);
